module.exports = __webpack_public_path__ + "img/apply_banner@2x.bc19c828.png";